import React from 'react';
import { Col, Navbar, Nav, Spinner, Dropdown, NavDropdown, Container, Image, Button, Modal, Form } from 'react-bootstrap';
import uuid from 'react-uuid';
import axios from 'axios';
import PropTypes from "prop-types";
import { Constants } from "../constants";
import { BrowserRouter as Router, Route, Link, NavLink, withRouter, Redirect } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';

class SiteMenu extends React.Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };
    constructor(props) {
        super(props);

        this.state = {
            user: props.user,
            currentPage: props.currentPage != null ? props.currentPage : 'self',
            showModal: false,
            contractorPin: '',
            loading: false,
            showTechnicianModal: false,
            employeeID: ''
        };

        this.logout = this.logout.bind(this);
        this.feedback = this.feedback.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleContractorSubmit = this.handleContractorSubmit.bind(this);
        this.handleContractorPin = this.handleContractorPin.bind(this);
        this.showButton = this.showButton.bind(this);

        this.handleTechnicianClose = this.handleTechnicianClose.bind(this);
        this.handleTechnicianSubmit = this.handleTechnicianSubmit.bind(this);
        this.handleTechnicianPin = this.handleTechnicianPin.bind(this);
        this.showTechnicianButton = this.showTechnicianButton.bind(this);

    }

    componentDidUpdate(prevProps) {
        console.log(prevProps);
        if (prevProps.user !== this.props.user) {
            this.setState({ user: this.props.user });
        }
    }

    componentDidMount() {

        if (this.state.currentPage == "openOrdersPage" || this.state.currentPage == "orderHistory" || this.state.currentPage == "buildingServiceView") {
            axios.get(`${Constants.apiURL}/api/Request/page_hit`, {
                params: {
                    user: this.state.user.username,
                    pageName: this.state.currentPage
                }
            }).then(response => {
            }).catch((response) => {
            });
        }
    }
    handleTechnicianClose() {
        this.setState({ showTechnicianModal: false });
    }

    handleTechnicianPin(event) {
        this.setState({
            employeeID: event.target.value
        });
    }
    showTechnicianButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>;
        }
        else {
            return <Button type='button' variant="primary" name="confirm" onClick={this.handleTechnicianSubmit} style={{ backgroundColor: '#1F419B' }}>
                Submit
            </Button>;
        }
    }
    handleTechnicianSubmit(e) {
        e.preventDefault();
        this.setState({ loading: true });
        axios.get(`${Constants.apiURL}/api/Identity/LoginTechnician`, {
            params: {
                username: this.state.user.username,
                email: this.state.user.email,
                employeeID: this.state.employeeID
            }
        }).then(response => {
                this.setState({
                    showTechnicianModal: false,
                    loading: false
                });
                this.props.history.push({
                    pathname: "/building_service_view_admin",
                    state: {
                        user: this.state.user,
                        hasAccess: true
                    }
                });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            alert('Cannot verify technician access. Please email clientportal@boland.com for help.')
        });
    }

    handleContractorPin(event) {
        this.setState({
            contractorPin: event.target.value
        });
    }
    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>;
        }
        else {
            return <Button variant="primary" name="confirm" onClick={this.handleContractorSubmit} style={{ backgroundColor: '#1F419B' }}>
                Submit
            </Button>;
        }
    }
    handleContractorSubmit() {
        this.setState({ loading: true });
        axios.get(`${Constants.apiURL}/api/Identity/LoginContractor`, {
            params: {
                username: this.state.user.username,
                contractorPin: this.state.contractorPin
            }
        }).then(response => {
            if (response.data) {
                this.setState({
                    showModal: false,
                    loading: false
                });
                this.props.history.push({
                    pathname: "/contractor_portal",
                    state: {
                        user: this.state.user,
                        contractor: response.data
                    }
                });
            }
            else {
                alert('Invalid access code.');
                this.setState({
                    loading: false
                });
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }
    handleClose() {
        this.setState({ showModal: false });
    }

    logout() {
        const cID = document.cookie
            .split("; ")
            .find((row) => row.startsWith("userID="))
            ?.split("=")[1];
        const cEmail = document.cookie
            .split("; ")
            .find((row) => row.startsWith("userEmail="))
            ?.split("=")[1];
        axios.post(`${Constants.apiURL}/api/Identity/Logout`).then(response => {
            if (cID === undefined || cEmail === undefined) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            else {
                window.location = `${Constants.apiURL}/BolandSec/home/Signout`;
                //window.location = "https://clientportalStaging.boland.com/BolandSec/home/Signout";
                //        window.location = "https://localhost:44370/home/Signout";
            }
        }).catch((response) => {
        });
    }

    feedback() {

        this.props.history.push({
            pathname: "/feedback",
            state: {
                user: this.state.user,
                previousPage: this.state.currentPage
            }
        });
    }

    render() {
        const showModal = this.state.showModal;
        const showTechnicianModal = this.state.showTechnicianModal;
        return (
            <Navbar className="boland-navbar" collapseOnSelect expand="md" defaultExpanded={false} sticky="top">
                <Modal show={showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton style={{ backgroundColor:'#1F419B', color:'#FFFFFF'}}>
                        <Modal.Title>Contractor Portal Login</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={(e) => { e.preventDefault(); }}>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Enter your contractor access code:</Form.Label>
                                <Form.Control autoFocus onChange={this.handleContractorPin} maxLength="20"/>
                            </Form.Group>
                            <Form.Label style={{fontStyle:'italic'}}>Not sure of your access code?<br/>Please contact your Boland salesperson.</Form.Label>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'flex-start' }}>
                        {this.showButton()}
                        <Button variant="secondary" name="cancel" onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showTechnicianModal} onHide={this.handleTechnicianClose}>
                    <Modal.Header closeButton style={{ backgroundColor: '#1F419B', color: '#FFFFFF' }}>
                        <Modal.Title>Technician Authentication</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={(e) => { e.preventDefault();}}>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Enter your employee ID:</Form.Label>
                                <Form.Control autoFocus onChange={this.handleTechnicianPin} maxLength="20" />
                            </Form.Group>
                            <Form.Label style={{ fontStyle: 'italic' }}>Unsure of your employee ID?<br />Email clientportal@boland.com for help.</Form.Label>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'flex-start' }}>
                        {this.showTechnicianButton()}
                        <Button variant="secondary" name="cancel" onClick={this.handleTechnicianClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Container style={{marginLeft:'0px', maxWidth:'100%'}}>
                    <Navbar.Brand as={Link} to={{
                        pathname: "/landing_page",
                        state: {
                            user: this.state.user
                        }
                    }} style={{ margin: 0, padding: 0 }}>
                        <Image src="./Boland block 2.png" width="165px" height="40px" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ml-auto" style={{ width: '100%' }}>
                            <NavDropdown title="New Order" id="collasible-nav-dropdown" style={{ paddingLeft: '20px' }}>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/service_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Service Request</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/rental_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Rental Equipment</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/parts_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Parts and Supplies</Dropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Consultation" id="collasible-nav-dropdown">
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Equipment Inquiry"
                                    }
                                }}>Equipment Inquiry</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Control Solutions"
                                    }
                                }}>Control Solutions</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Service Contract"
                                    }
                                }}>Service Contract</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Indoor Air Quality"
                                    }
                                }}>Indoor Air Quality</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Energy Optimization"
                                    }
                                }}>Energy Optimization</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Building Performance"
                                    }
                                }}>Building Performance</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Water Technologies"
                                    }
                                }}>Water Technologies</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Rental Services"
                                    }
                                }}>Rental Services</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Capital Asset Planning"
                                    }
                                }}>Capital Asset Planning</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "Parts & Supplies Inventory Planning"
                                    }
                                }}>Parts & Supplies Inventory Planning</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/consultation_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        typeofrequest: "HVAC System Design & Build"
                                    }
                                }}>HVAC System Design & Build</Dropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Tracking" id="collasible-nav-dropdown" hidden={!(this.state.user.hasAccount || this.state.user.isInternal)}>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/open_orders",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Open Orders</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/orders",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Order History</Dropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Reporting" id="collasible-nav-dropdown" hidden={!(this.state.user.hasAccount || this.state.user.isInternal)}>
                                <Dropdown.Item hidden={!this.state.user.isInternal} onClick={() => { this.setState({ showTechnicianModal: true }); }}>
                                    Virtual Lock Box
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/building_service_view",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Building Service Log</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/open_orders_report",
                                    key: uuid(),  
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Open Service Orders</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/predictive_reporting",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Predictive Maintenance</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/refrigerant_reporting",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Refrigerant Reports</Dropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Account" id="collasible-nav-dropdown" hidden={!this.state.user.isAdmin && !this.state.user.isFullAccess}>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/account_selection",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        nextPath: '/open_invoices'
                                    }
                                }}>Open Invoices</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/account_selection",
                                    key: uuid()+1,
                                    state: {
                                        user: this.state.user,
                                        nextPath: '/customer_statement'
                                    }
                                }}>Customer Statement</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/w9_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>W-9 Request</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/coi_request",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>COI Request</Dropdown.Item>
                                {<Dropdown.Item as={Link} to={{
                                    pathname: "/account_selection",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user,
                                        nextPath: '/manage_wallet'
                                    }
                                }}>Manage Wallet</Dropdown.Item>}
                            </NavDropdown>
                            <Button className="justify-content-end" style={{ justifyContent: 'end', backgroundColor: '#1F419B', minWidth: 'fit-content' }} onClick={() => { this.setState({ showModal: true }); }}>
                                Contractors
                            </Button>
                            <NavDropdown title="Training" id="collasible-nav-dropdown" >
                                {<Dropdown.Item as={Link} to={{
                                    pathname: "/training",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Class Registration</Dropdown.Item>}
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/my_training",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>My Training Classes</Dropdown.Item>
                            </NavDropdown>
                            <div style={{ width: '100%' }} />
                            <Nav.Link href="https://www.boland.com/news" target="_blank">News</Nav.Link>
                            <NavDropdown title="Admin" id="collasible-nav-dropdown" hidden={!this.state.user.isAdmin && !this.state.user.isInternal}>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/user_manager",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Manage Users</Dropdown.Item>
                                <Dropdown.Item as={Link} hidden={!this.state.user.isInternal} to={{
                                    pathname: "/service_report_upload",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Service Reporting</Dropdown.Item>
                                <Dropdown.Item as={Link} hidden={!this.state.user.isInternal} to={{
                                    pathname: "/download_cert",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Training Cert Download</Dropdown.Item>
                                <Dropdown.Item as={Link} hidden={!this.state.user.isInternal} to={{
                                    pathname: "/concierge_main",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Service Concierge</Dropdown.Item>
                                {/*<Dropdown.Item as={Link} hidden={!this.state.user.isInternal} to={{*/}
                                {/*    pathname: "/Manage_Building_Location",*/}
                                {/*    key: uuid(),*/}
                                {/*    state: {*/}
                                {/*        user: this.state.user*/}
                                {/*    }*/}
                                {/*}}>Manage Building Location</Dropdown.Item>*/}
                                <Dropdown.Item as={Link} hidden={!this.state.user.isInternal} to={{
                                    pathname: "/location_filter",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>Location Filter</Dropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="My Profile" id="collasible-nav-dropdown">
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/manage_accounts",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>My Accounts</Dropdown.Item>
                                <Dropdown.Item as={Link} to={{
                                    pathname: "/user_settings",
                                    key: uuid(),
                                    state: {
                                        user: this.state.user
                                    }
                                }}>User Settings</Dropdown.Item>
                            </NavDropdown>
                            <Button size="sm" className="justify-content-end button-feedback" style={{ justifyContent: 'end', backgroundColor: '#EF4139', minWidth: 'max-content' }} onClick={this.feedback}>
                                Feedback?
                            </Button>
                            <Button className="justify-content-end" style={{ justifyContent: 'end', backgroundColor: '#1F419B'}} onClick={this.logout}>
                                    Logout
                            </Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        );
    }
}
export default withRouter(SiteMenu);